export const CASE_SPIN_DURATION_MS = 10000;

/**
 * @param {number} reelLength
 * @param {number} winningIndex
 * @param {number} amount
 * @returns {number}
 */
export function getReelWinnerIndex(reelLength, winningIndex, amount) {
  if (!Number.isInteger(winningIndex) || winningIndex < 0 || winningIndex >= reelLength) {
    throw new Error("Invalid case winning index");
  }
  return winningIndex + (amount === 1 ? reelLength : 0);
}

/**
 * @param {number} viewportWidth
 * @param {number} winnerLeft
 * @param {number} winnerWidth
 * @returns {number}
 */
export function getReelStopOffset(viewportWidth, winnerLeft, winnerWidth) {
  return viewportWidth / 2 - winnerLeft - winnerWidth / 2;
}
